export class Pagination {
  public static getNumbers() {
    return [{value: 10}, {value: 20}, {value: 30}, {value: 50}];
  }
}
